
  import {init as runtimeInit, loadRemote} from "@module-federation/runtime";
  
  import exposesMap from "virtual:mf-exposes"
  import {usedShared, usedRemotes} from "/appdata/install/jenkins/CloudbeesCI_Workspace/executors/2/workspace/I_vista_release_v2.10.0-hotfix.2/.__mf__temp/vista/localSharedImportMap"
  import {
    initResolve
  } from "__mf__virtual/vista__mf_v__runtimeInit__mf_v__.js"
  const initTokens = {}
  const shareScopeName = "default"
  const mfName = "vista"
  async function init(shared = {}, initScope = []) {
    const initRes = runtimeInit({
      name: mfName,
      remotes: usedRemotes,
      shared: usedShared,
      plugins: [],
      shareStrategy: 'loaded-first'
    });
    // handling circular init calls
    var initToken = initTokens[shareScopeName];
    if (!initToken)
      initToken = initTokens[shareScopeName] = { from: mfName };
    if (initScope.indexOf(initToken) >= 0) return;
    initScope.push(initToken);
    initRes.initShareScopeMap('default', shared);
    try {
      await Promise.all(await initRes.initializeSharing('default', {
        strategy: 'loaded-first',
        from: "build",
        initScope
      }));
    } catch (e) {
      console.error(e)
    }
    initResolve(initRes)
    return initRes
  }

  function getExposes(moduleName) {
    if (!(moduleName in exposesMap)) throw new Error(`Module ${moduleName} does not exist in container.`)
    return (exposesMap[moduleName])().then(res => () => res)
  }
  export {
      init,
      getExposes as get
  }
  